(function ($) {
  // background animation
  var time = 0;
  setInterval(function () {
    time += 1;
    $(".ayn-AnimateBg_bg01").css(
      "background-position",
      "center " + -time * 0.15 + "px"
    );
    $(".ayn-AnimateBg_bg02").css(
      "background-position",
      "center " + -time * 0.1 + "px"
    );
    $(".ayn-AnimateBg_bg03").css(
      "background-position",
      "center " + -time * 0.2 + "px"
    );
  }, 1);
})($brand);
